import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number | string;
}

const Aksessuary: React.FC<IconProps> = ({
 color = "#2625e9",
  size = 40,
  className,
  style,
  ...props
}) => (
  <svg
    transform="scale(1.5)"
    viewBox="0 0 80 80"
    style={{ width: size, height: size, flexShrink: 0, ...style }}
    aria-hidden="true"
    className={className}
    {...props}
  >
<g transform="translate(0,-0)">
    <path
      fill={color}
      d="M30.87 75.22c-.49 0-.98-.13-1.44-.39-1.3-.74-1.86-2.25-1.36-3.68l.02-.06.03-.06L35.5 58.1c.04-.16-.02-.28-.28-.66-.36-.51-.9-1.29-.51-2.56l.03-.09.05-.08c1.38-2.11 2.62-4.47 3.83-6.76 1.23-2.35 2.51-4.78 3.94-6.94l.08-.12c.73-1.11 1.55-2.36 3.38-1.9l8-13.43.06-.06c.6-.62 1.46-.95 2.35-.9.87.05 1.66.45 2.17 1.11.53.68.72 1.6.51 2.46l-.02.09-.05.08-25.88 45.75-.04.05c-.6.71-1.41 1.08-2.23 1.08zm-1.51-3.56c-.28.9.17 1.63.76 1.96.51.29 1.27.35 1.89-.33l25.77-45.54c.08-.42-.02-.87-.28-1.2-.26-.34-.68-.55-1.14-.57-.47-.03-.91.13-1.23.43l-8.5 14.27-.55-.22c-1.14-.46-1.41-.13-2.28 1.18l-.08.12c-1.39 2.11-2.65 4.51-3.87 6.83-1.2 2.29-2.44 4.65-3.83 6.79-.15.56.05.85.35 1.27.31.45.74 1.06.45 1.95l-.02.07-7.42 13zM36.44 73.46c-.41 0-.85-.1-1.29-.29l-.71-.31 25.19-43.85.64.56c1.35 1.19 1.03 2.58.6 3.65l-.04.08-21.78 38.33c-.64 1.19-1.55 1.82-2.6 1.82zm23.4-42.02L36.5 72.07c.43-.03.9-.29 1.33-1.09L59.6 32.67c.2-.52.29-.91.24-1.23zM21.74 55.41c-.49 0-.98-.13-1.44-.39-1.3-.74-1.86-2.25-1.36-3.68l.02-.06 7.41-12.99c.04-.16-.02-.28-.28-.66-.36-.51-.9-1.29-.51-2.56l.03-.09.05-.08c1.38-2.11 2.62-4.47 3.83-6.76 1.23-2.35 2.51-4.78 3.94-6.94l.08-.12c.73-1.11 1.55-2.36 3.38-1.9l8-13.43.06-.06c.6-.62 1.46-.95 2.35-.9.87.05 1.66.45 2.17 1.11.53.68.72 1.6.51 2.46l-.02.09-.05.08-25.88 45.75-.04.05c-.6.71-1.41 1.08-2.23 1.08zm-1.5-3.56c-.28.9.17 1.63.76 1.96.51.29 1.27.35 1.89-.33L48.65 7.94c.08-.42-.02-.87-.28-1.2-.26-.34-.68-.55-1.14-.57-.47-.03-.91.13-1.23.43l-8.5 14.27-.55-.22c-1.14-.46-1.41-.13-2.28 1.18l-.08.12c-1.39 2.11-2.65 4.51-3.87 6.83-1.2 2.29-2.45 4.65-3.84 6.79-.15.56.05.85.35 1.27.31.45.74 1.06.45 1.95l-.02.07-7.42 13zM27.31 53.65c-.41 0-.85-.1-1.29-.29l-.71-.31L50.5 9.2l.64.56c1.35 1.19 1.03 2.58.6 3.65l-.04.08-21.78 38.33c-.64 1.19-1.55 1.82-2.6 1.82zm23.4-42.02L27.37 52.26c.43-.03.9-.29 1.33-1.09l21.77-38.31c.2-.52.29-.91.24-1.23z"
    />
    </g>
  </svg>
);

export default Aksessuary;